import React, { useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
  putAPI_Update_RatePlan_RoomMapping,
  gAPI_RatePlans_By_Id,
} from '../../../../../../../constants/APIs';
import PropTypes from 'prop-types';
import Validation from '../../../../../../../components/Validation';
export default function LinkRoomForm({ id, linkRoomList }) {
  const [name, setName] = useState('id');
  const [rooms, setRooms] = useState([]);
  const [visible, setVisible] = useState(false);
  const [roomList, setRoomList] = useState(linkRoomList || []);
  const [input, setInput] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_RatePlans_By_Id}/${id}`,
    })
      .then(res => {
        setName(res.data.name[0].statement);
        setRooms(res.data.rooms);
      })
      .catch(err => console.log('err', err));
  }, [id]);

  /** If the rooms of rate plan has value,
   *  then set the corresponding check box to be checked status.
   */
  useEffect(() => {
    const vlues = roomList.map(elem => {
      rooms.forEach(room => {
        if (room.id === elem.id) {
          elem.checked = true;
        }
      });
      return {
        ...elem,
      };
    });
    setRoomList(vlues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rooms]);

  useEffect(() => {
    const appAddonsArr = roomList
      .filter(elem => elem.checked === true)
      .map(elem => ({
        roomId: elem?.id,
        name: elem?.name,
      }));
    setInput({
      rooms: appAddonsArr,
    });
  }, [roomList]);

  const handleRoomListChange = e => {
    const values = roomList.map(elem => {
      if (elem.id === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setRoomList(values);
  };

  const handleSubmit = () => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_RatePlan_RoomMapping}/${id}`,
      data: input,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    })
  };

  return (
    <div>
      <Button color="primary" size="xs" onClick={() => setVisible(!visible)}>
        Link Room
      </Button>
      <Modal isOpen={visible} toggle={() => setVisible(!visible)}>
        <ModalHeader toggle={() => setVisible(!visible)}>
          <div> Edit Link Rooms - {name}</div>
        </ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              {/* <pre>code: {JSON.stringify(input, null, 2)}</pre> */}
              <Row>
                <Colxx sm={12}>
                  <FormGroup>
                    {roomList.map((elem, index) => (
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.id}
                        id={elem.id}
                        onChange={handleRoomListChange}
                        checked={elem.checked}
                      >
                        {elem.name}
                      </CustomInput>
                    ))}
                  </FormGroup>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setVisible(!visible);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}

LinkRoomForm.propTypes = {
  id: PropTypes.string.isRequired,
  linkRoomList: PropTypes.array.isRequired,
};
